export class TrainingAttendance {
    ClassID: number;
    ClassName: string;
    TrainerID: number;
    TrainerName: string;
    EventDate: Date;
    CountEnrolled: number;
    CountAttended: number;

    public static FixDates(item: TrainingAttendance) {
        item.EventDate = new Date(item.EventDate);
    }

}

export class TrainingAttendanceArray extends Array<TrainingAttendance> {

    constructor(...items: TrainingAttendance[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingAttendanceArray.prototype);
    }

    public static FixDates(item: TrainingAttendanceArray) {
        item.forEach(x => TrainingAttendance.FixDates(x));
    }


}
